import {Injectable} from '@angular/core';

function _window(): Record<string, unknown> {
    // return the global native browser window object
    return window as unknown as Record<string, unknown>;
}
@Injectable()
export class WindowRef {
    getGlobalVarValue<T>(globalVarName: string): T {
        return _window()[globalVarName] as T;
    }
}
